import React, { ComponentType, useEffect, useState } from "react";
import { CpModal, CpOverlay } from "@components";
import { ModalContainerComponentProps } from "../../components/cp-modal/modal-container.component";

type ModalServiceEntryProps<
  T extends Record<string, unknown> = Record<string, unknown>,
> = {
  id: string;
  component: ComponentType<T & { onSubmit: (data: unknown) => void }>;
  props?: Omit<T, "onSubmit">;
  modalProps?: ModalContainerComponentProps & { overlay?: boolean };
  onSubmit: (id: string, data: unknown) => void;
};

export function ModalServiceEntry<
  T extends Record<string, unknown> = Record<string, unknown>,
>({ id, component, props, modalProps, onSubmit }: ModalServiceEntryProps<T>) {
  const [show, setShow] = useState(true);
  const [data, setData] = useState<unknown>(false);
  const Component = component;

  useEffect(() => {
    if (!show) setTimeout(() => onSubmit(id, data), 500);
    /* Add missing deps and verify it doesn't break: data, id, onSubmit (memoize or store in ref) */
  }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  function submit(data: unknown) {
    setData(data);
    setShow(false);
  }

  const ModalComponent = modalProps?.overlay ? CpOverlay : CpModal;

  return (
    <ModalComponent {...modalProps} show={show} onClose={() => submit(false)}>
      <Component {...(props as T)} onSubmit={submit} />
    </ModalComponent>
  );
}
